import React from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { FilePdf, Printer } from '@phosphor-icons/react';
import { Button } from './ui/button';
import { openPdfInBrowser, printPdf } from '../utils/pdfUtils';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const KINDS = {
  payments: { idKey: 'payment_id', idsField: 'payment_ids', req: '/purchases/payments/print-requests', pdf: '/purchases/payments/pdf', el: 'πληρωμές', en: 'payments' },
  invoices: { idKey: 'invoice_id', idsField: 'invoice_ids', req: '/purchases/invoice-list/print-requests', pdf: '/purchases/invoice-list/pdf', el: 'τιμολόγια', en: 'invoices' },
};

// Export PDF / Print for supplier records: the selected rows if any, otherwise every row matching the filters.
export const SupplierPaymentsPrintBar = ({ kind = 'payments', filtered, selected, setSelected, el, meta }) => {
  const k = KINDS[kind];
  const visible = new Set(filtered.map((r) => r[k.idKey]));
  const hiddenSelected = [...selected].filter((id) => !visible.has(id)).length;
  const toPrint = selected.size ? [...selected] : filtered.map((r) => r[k.idKey]);
  const run = (fn) => async () => {
    if (!toPrint.length) { toast.error(el ? 'Δεν υπάρχουν εγγραφές για εκτύπωση' : 'Nothing to print'); return; }
    try {
      const r = await axios.post(`${API}${k.req}`, {
        [k.idsField]: toPrint, mode: selected.size ? 'selected' : 'filtered', ...meta,
      }, { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      await fn(k.pdf, { req_id: r.data.req_id, lang: el ? 'el' : 'en' });
    } catch (e) { toast.error(e.response?.data?.detail || e.message || 'PDF error'); }
  };
  const allVisible = filtered.length > 0 && filtered.every((r) => selected.has(r[k.idKey]));
  const p = `purchases-${kind === 'payments' ? 'pay' : 'inv'}`;
  return (
    <div className="flex items-center gap-2 flex-wrap mb-2 text-xs" data-testid={`${p}-print-bar`}>
      <Button variant="outline" size="sm" className="rounded-none h-7 text-xs" disabled={allVisible || !filtered.length}
        onClick={() => setSelected(new Set([...selected, ...filtered.map((r) => r[k.idKey])]))} data-testid={`${p}-select-all`}>Select All</Button>
      <Button variant="outline" size="sm" className="rounded-none h-7 text-xs" disabled={!selected.size}
        onClick={() => setSelected(new Set())} data-testid={`${p}-deselect-all`}>Deselect All</Button>
      <span className="text-zinc-600" data-testid={`${p}-selected-count`}>
        {el ? 'Επιλεγμένα' : 'Selected'}: <b className="text-zinc-900">{selected.size}</b>
        {hiddenSelected > 0 && <span className="text-amber-700"> ({hiddenSelected} {el ? 'εκτός τρεχόντων φίλτρων — θα εκτυπωθούν' : 'outside current filters — will be printed'})</span>}
      </span>
      <span className="text-zinc-400" data-testid={`${p}-print-scope`}>
        · {el ? 'Θα εκτυπωθούν' : 'Will print'}: {toPrint.length} {selected.size ? (el ? 'επιλεγμένα' : 'selected') : (el ? `φιλτραρισμένα ${k.el}` : `filtered ${k.en}`)}
      </span>
      <div className="ml-auto inline-flex border border-zinc-300 bg-white">
        <Button variant="ghost" size="sm" className="rounded-none h-7 px-2 text-xs" onClick={run(openPdfInBrowser)} data-testid={`${p}-export-pdf`}>
          <FilePdf size={14} className="mr-1" />{selected.size ? 'Export Selected to PDF' : 'Export PDF'}
        </Button>
        <Button variant="ghost" size="sm" className="rounded-none h-7 px-2 text-xs border-l border-zinc-200" onClick={run(printPdf)} data-testid={`${p}-print`}>
          <Printer size={14} className="mr-1" />{selected.size ? 'Print Selected' : 'Print'}
        </Button>
      </div>
    </div>
  );
};
